import React from "react";
import { BsPlusSquare } from "react-icons/bs";
import { GoChecklist } from "react-icons/go";
import Loading from "../../Components/Loading";
import { useCreateAds } from "./Hooks";
import GroupingItem from "../../Components/GroupingItem";
import { Spinner } from "react-bootstrap";
import Region from "../../Components/Region";
import ImageUploader from "../../Components/ImageUploader";
import Keywords from "../../Components/Keywords";
import { renderPrice } from "../../Utils/functions";
import { MdVerifiedUser } from "react-icons/md";
import { HiOutlineChevronDoubleLeft, HiOutlineChevronDoubleRight } from "react-icons/hi";
const CreateAds = () => {
  const {
    form,
    loading,
    dispatch,
    init,
    getValue,
    navigate,
    changeObj,
    setForm,
    store,
    value,
    handler,
    edit,
    user,
    renderTotoalPrice,
    stepHandler,
    publised,
    prevStep,
    loadingCheck,
    check
  } = useCreateAds();
  const render = () => {
    switch (form.step) {
      case "selectCategory":
        return (
          <>
            {loading.get ? (
              <Loading height={"30px"} count={5} />
            ) : (
              <>
                {getValue("category_id") ? (
                  <>
                    {init.categories
                      .filter(ca => ca.id == getValue("category_id"))[0]
                      .childs.map((item, key) => {
                        return (
                          <div key={key} className="col-12">
                            <GroupingItem
                              item={item}
                              onClick={() => {
                                setForm({
                                  ...form,
                                  step: 1,
                                  category_id: item.id,
                                });
                              }}
                            />
                          </div>
                        );
                      })}
                  </>
                ) : (
                  init.categories.map((item, key) => {
                    return (
                      <div key={key} className="col-12">
                        <GroupingItem
                          item={item}
                          onClick={() => {
                            if (item.childs?.length > 0) {
                              changeObj("category_id", item.id);
                            } else {
                              dispatch("category", item);
                            }
                          }}
                        />
                      </div>
                    );
                  })
                )}
              </>
            )}
          </>
        );
      case 1:
        return (
          <>
            <form>
              <div className="form-group">
                <label htmlFor="title" className="labelinput">عنوان آگهی</label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  aria-describedby="titleHelp"
                  placeholder="عنوان آگهی خود را وارد نمایید(200 کاراکتر)"
                  onChange={({ target: { value } }) => {
                    handler("title", value);
                  }}
                  value={value("title")}
                />
                <small id="titleHelp" className="form-text text-muted">
                  در عنوان بهتر است از ویژگی های متمایز نام برده شود
                </small>
              </div>
              <div className="form-group">
                <label htmlFor="description" className="labelinput">توضیحات</label>
                <textarea
                  type="text"
                  className="form-control"
                  id="description"
                  aria-describedby="descriptionHelp"
                  placeholder="توضیحات محصول را اینجا وارد نمایید"
                  onChange={({ target: { value } }) => {
                    handler("description", value);
                  }}
                  rows={8}
                  value={value("description")}
                />
                <small id="descriptionHelp" className="form-text text-muted">
                  توضیحات راجع به محصول موردنظر
                </small>
              </div>
              <div className="form-group">
                <label className="form-label labelinput" htmlFor="first-name">
                  نوع آگهی
                </label>
                <select
                  className="form-control"
                  id="type"
                  type="text"
                  onChange={({ target: { value } }) => {
                    handler("model", value);
                  }}
                  aria-describedby="typeHelp"
                  value={value("model")}
                >
                  <option>انتخاب کنید</option>
                  <option value={"sale"}>فروش</option>
                  <option value={"request"}>درخواست</option>
                  <option value={"rent"}>اجاره</option>
                  <option value={"introduction"}>معرفی</option>
                  <option value={"buy"}>خرید</option>
                  <option value={"other"}>سایر</option>
                </select>
                <small id="typeHelp" className="form-text text-muted">
                  توضیحات راجع به محصول موردنظر
                </small>
              </div>
            </form>
          </>
        );
        return;
      case 2:
        return (
          <div className="row">
            <div className="col-12">
              <Region set={handler} value={value} />
            </div>
            <div className="col-12">
              <label className="form-label labelinput" htmlFor="first-name">
                آدرس
              </label>

              <input
                className="form-control"
                id="first-name"
                type="text"
                placeholder="آدرس آگهی را وارد نمایید"
                onChange={({ target: { value } }) => {
                  handler("addres", value);
                }}
                value={value("addres")}
              />
              <small className="fs-10">آدرس مورد نظر را دقیق وارد کنید</small>
            </div>
          </div>
        );
      case 3:
        return (
          <>
            <div className="">
              <div className="row justify-content-center">
                <div className="col-12">
                  <ImageUploader
                    element={{
                      key: "main_image",
                      label: "عکس اصلی",
                      subLabel: "عکس شاخص محصول خود را بارگذای نمایید",
                    }}
                    form={form}
                    setForm={setForm}
                    single={true}
                  />
                  <ImageUploader
                    element={{
                      key: "product_images",
                      label: "عکس های محصول",
                      subLabel: "می توانید چندین عکس را بارگذاری نمایید",
                    }}
                    form={form}
                    setForm={setForm}
                    single={false}
                  />
                  <Keywords
                    form={form}
                    setForm={setForm}
                    options={{
                      title: "کلمات کلیدی",
                      key: "keywords",
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        );
      case 4:
        return (
          <div className="row justify-content-center mb-4">
            <div className="col-12 ">
              <div className="mb-2">
                <label className="labelinput">نوع شخص آگهی دهنده</label>
                <p className="fs-10 mb-1">مشخص کردن نوع شخص آگهی دهنده</p>
                <div className="d-flex align-items-center">
                  <div className="check-box-wrapper d-flex align-items-center ms-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDisabled"
                      id="flexRadioDisabled"
                      onClick={() => {
                        setForm({ ...form, type: "personal" });
                      }}
                      checked={form.type == "personal"}
                    />
                    <label className="form-check-label labelinput my-0 me-2"
                      htmlFor="flexRadioDisabled" >
                      شخصی
                    </label>
                  </div>
                  <div className="check-box-wrapper d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDisabled"
                      id="flexRadioCheckedDisabled"
                      onClick={() => {
                        setForm({ ...form, type: "company" });
                      }}
                      checked={form.type ? form.type == "company" : true}
                    />
                    {!form.type && setForm({ ...form, type: "company" })}
                    <label
                      className="form-check-label labelinput  my-0 me-2"
                      htmlFor="flexRadioCheckedDisabled"
                    >
                      شرکتی
                    </label>
                  </div>
                </div>
              </div>
              <div>
                {form.type === "personal" ? (
                  <>
                    <div className="col-12">
                      <label className="form-label" htmlFor="first-name">
                        نام و نام خانوادگی
                      </label>

                      <input
                        className="form-control"
                        id="first-name"
                        type="text"
                        placeholder="نام و نام خانوادگی خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("fullname", value);
                        }}
                        value={form?.fullname}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label labelinput" htmlFor="first-name">
                        موبایل
                      </label>

                      <input
                        className="form-control"
                        id="first-name"
                        type="number"
                        placeholder="موبایل خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("mobile", value);
                        }}
                        value={user?.mobile}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label labelinput" htmlFor="first-name">
                        ایمیل
                      </label>

                      <input
                        className="form-control"
                        id="first-name"
                        type="email"
                        placeholder="ایمیل خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("email", value);
                        }}
                        value={user?.email}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-12">
                      <label className="form-label labelinput" htmlFor="first-name">
                        نام شرکت
                      </label>

                      <input
                        className="form-control"
                        id="co_name"
                        type="text"
                        placeholder="نام شرکت خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("co_name", value);
                        }}
                        value={value("co_name")}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label labelinput" htmlFor="first-name">
                        تلفن شرکت
                      </label>

                      <input
                        className="form-control"
                        id="co_tell"
                        type="number"
                        placeholder="تلفن شرکت خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("co_tell", value);
                        }}
                        value={value("co_tell")}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label labelinput" htmlFor="first-name">
                        موبایل شرکت
                      </label>

                      <input
                        className="form-control"
                        id="co_mobile"
                        type="number"
                        placeholder="موبایل شرکت خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("co_mobile", value);
                        }}
                        value={value("co_mobile")}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label labelinput" htmlFor="first-name">
                        آدرس شرکت
                      </label>

                      <input
                        className="form-control"
                        id="co_addres"
                        type="text"
                        placeholder="آدرس شرکت خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("co_addres", value);
                        }}
                        value={value("co_addres")}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label labelinput" htmlFor="first-name">
                        آدرس وب سایت
                      </label>

                      <input
                        className="form-control"
                        id="co_url"
                        type="url"
                        placeholder="آدرس وب سایت شرکت خود را وارد کنید"
                        onChange={({ target: { value } }) => {
                          handler("co_url", value);
                        }}
                        value={value("co_url")}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="col-12">
                <label className="form-label labelinput" htmlFor="first-name">
                  قیمت آگهی (تومان)
                </label>

                <div className="check-box-wrapper mb-3 mt-1">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dwkadmakwmdk"
                    id="tavaCheck"
                    onClick={() => {
                      setForm({ ...form, tava: !form.tava });
                    }}
                    checked={form.tava}
                  />
                  <label className="form-check-label labelinput" htmlFor="tavaCheck">
                    قیمت به صورت توافقی
                  </label>
                </div>

                <input
                  className="form-control"
                  id="first-name"
                  type="number"
                  placeholder=" قیمت را وارد کنید"
                  onChange={({ target: { value } }) => {
                    handler("price", value);
                  }}
                  disabled={form.tava}
                  value={value("price")}
                />
              </div>
            </div>
          </div>
        );
      case 5:
        return (
          <div className="">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="col-12">
                  <label className="labelinput">انتخاب تنظیمات آگهی</label>
                  <div>
                    <span className="fs-10">نوع قیمت گذاری را انتخاب کنید</span>
                  </div>
                  {init?.options?.map(op => {
                    return (
                      <div className="option mt-2" key={op.id}>
                        <div>
                          <MdVerifiedUser color="#0099FF" size={"1.5rem"} />
                        </div>
                        <div className="option-content">
                          <p className="title">{op.title}</p>
                          <p className="description">{op.description}</p>
                        </div>
                        <div className="check-box">
                          <input
                            className="form-check-input"
                            type="radio"
                            name={`flexRadioDisabled${op.id}`}
                            id={`flexRadioDisabled${op.id}`}
                            onClick={() => {
                              if (form.option?.length > 0) {
                                if (form.option.includes(op.id)) {
                                  setForm({
                                    ...form,
                                    option: form.option.filter(
                                      de => de != op.id
                                    ),
                                  });
                                } else {
                                  setForm({
                                    ...form,
                                    option: [...form.option, op.id],
                                  });
                                }
                              } else {
                                setForm({ ...form, option: [op.id] });
                              }
                            }}
                            checked={form.option.includes(op.id)}
                          />
                          <label
                            className="form-check-label labelinput"
                            htmlFor={`flexRadioDisabled${op.id}`}
                          >
                            {renderPrice(op.price)}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <hr />
            <div className="row mb-2">
              <div className="col">
                <h5 className="fs-15 fs-500">ثبت کد تخفیف</h5>
              </div>
            </div>

            <div className="row g-3 justify-content-between">
              <div className="col">
                <label htmlFor="inputPassword2" className="visually-hidden">
                  کد تخفیف
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="inputPassword2"
                  placeholder="کد تخفیف"
                  onChange={({ target: { value } }) => {
                    setForm({ ...form, off_code: value });
                  }}
                />
              </div>
              <div className="col-auto">
                <button
                  type="submit"
                  onClick={check}
                  className="btn btn-primary mb-3"
                >
                  {loadingCheck ? <Spinner size="sm" /> : "ثبت کد تخفیف"}
                </button>
              </div>
            </div>

            <hr />
            <div className="d-flex justify-content-between">
              <p className="fs-14 fw-light">هزینه آگهی : </p>
              <p className="fs-14 fw-bold text-danger">
                {form.category_price == "0" && form.option.length == 0
                  ? "رایگان"
                  : renderPrice(
                    renderTotoalPrice(init?.options) + +form.category_price
                  )}
              </p>
            </div>
            <div className="row justify-content-end mt-4">
              <div className="col-6 d-flex justify-content-start">
                <button className="btn btn-primary w-75 " onClick={prevStep} >
                  {handlerBtn().loading ? (
                    <>
                      <Spinner size="sm" />
                    </>
                  ) : (
                    <>
                      <HiOutlineChevronDoubleRight className="ms-2" />
                      مرحله قبل
                    </>
                  )}
                </button>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <button className="btn btn-primary w-75" onClick={publised}>
                  {loading.edit ? (
                    <>
                      <Spinner size="sm" />
                    </>
                  ) : form.category_price == "0" && form.option.length == 0 ? (
                    "ثبت آگهی"
                  ) : (
                    "ثبت و پرداخت آگهی"
                  )}
                </button>
              </div>
            </div>
          </div>
        );
      default:
        break;
    }
  };
  const handlerBtn = () => {
    let res = {
      loading: false,
      method: () => { },
    };
    switch (form.step) {
      case 1:
        res = {
          loading: loading.step1,
          method: store,
        };
        break;
      default:
        res = {
          loading: loading.edit,
          method: edit,
        };
        break;
    }
    return res;
  };
  return (
    <div className="create-ads">
      <div className="tiTle">
        <BsPlusSquare />

        <p className="txt">ثبت آگهی</p>
      </div>
      <div className="container mt-3">
        <div className="row">
          <div className="col-12 mt-2">
            <h4 className="fs-15">{stepHandler()}</h4>
          </div>

        </div>
        <div className="row">
          <div className="col-12">{render()}</div>
        </div>

        <div className="row mt-3">
          <div className="col-6 d-flex justify-content-start">
            {form.step > 1 && form.step < 5 &&
              < button className="btn btn-primary w-75 " onClick={prevStep} >
                {handlerBtn().loading ? (
                  <>
                    <Spinner size="sm" />
                  </>
                ) : (
                  <>
                    <HiOutlineChevronDoubleRight className="ms-2" />
                    مرحله قبل
                  </>
                )}
              </button>
            }
          </div>
          {![5, "selectCategory"].includes(form.step) && (
            <div className="col-6 d-flex justify-content-end">
              <button
                className="btn btn-primary w-75"
                onClick={handlerBtn().method}
              >
                {handlerBtn().loading ? (
                  <>
                    <Spinner size="sm" />
                  </>
                ) : (
                  <>
                    مرحله بعدی
                    <HiOutlineChevronDoubleLeft className="me-2" />
                  </>
                )}
              </button>
            </div>

          )}
        </div>
      </div>
    </div >
  );
};

export default CreateAds;
